import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import { DELETE_CHARGE_SPEED, FETCH_CHARGE_SPEED, GET_CHARGE_SPEED } from 'actions/chargeSpeed';
import ChargeSpeedForm from './ChargeSpeedForm';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import Avatar from 'components/inputs/Avatar';


const ChargeSpeedList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  // const [allChargeSpeedData, setAllChargeSpeedData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [chargeSpeedId, setChargeSpeedId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseChargeSpeedData, setPageWiseChargeSpeedData] = useState([]);

  const page = useSelector((state) => state.chargeSpeed.page);
  const totalData = useSelector((state) => state.chargeSpeed.total);
  const limit = useSelector((state) => state.chargeSpeed.limit);
  const totalPages = useSelector((state) => state.chargeSpeed.totalPages);
  const chargeSpeedList = useSelector((state) => state.chargeSpeed.chargeSpeed);
  const isLoader = useSelector((state) => state.chargeSpeed.isLoading);

  const chargerSpeedData = chargeSpeedList.filter(({ id: id1 }) => pageWiseChargeSpeedData.some(({ id: id2 }) => id2 === id1));

  const getChargeSpeed = useCallback(
    (data = {}) => {
      if (searchText) {
        const searchChargeSpeedData = {
          ...data,
          search: searchText,
        };
        dispatch({
          type: FETCH_CHARGE_SPEED.REQUEST,
          payload: searchChargeSpeedData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseChargeSpeedData(res.data.results);
              }
            }
          },
        });
      } else {
        dispatch({
          type: FETCH_CHARGE_SPEED.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200) {
                setPageWiseChargeSpeedData(res.data.results);
              }
            }
          },
        });
      }
    },
    [pageWiseChargeSpeedData, searchText]
  );

  const getChargeSpeedDetail = useCallback((id) => {
    dispatch({ type: GET_CHARGE_SPEED.REQUEST, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setChargeSpeedId('');
  };

  const deleteChargeSpeed = useCallback(
    () =>
      dispatch({
        type: DELETE_CHARGE_SPEED.REQUEST,
        payload: chargeSpeedId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getChargeSpeed({ page: 1 });
          }
        },
      }),
    [chargeSpeedId]
  );

  useEffect(() => {
    getChargeSpeed();
  }, []);

  const handleSearch = () => {
    getChargeSpeed({});
  };

  // useEffect(() => {
  //   setAllChargeSpeedData(_.filter(chargerSpeedData, (item) => startsWith(_.get(item, 'name', ''), searchText)));
  // }, [searchText, chargeSpeedList, pageWiseChargeSpeedData]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getChargeSpeed(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getChargeSpeed(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getChargeSpeed(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormChargeSpeed = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.chargeSpeed')} />
        <div className="page-content-wrapper scrollable">
          <div className="chargeSpeedList-page">
            <Card>
              <div className="chargeSpeedList-page-wrapper">
                <Row className="chargeSpeedList-search-box">
                  <Col xl={10} lg={9} md={8} className="chargeSpeedList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      preIcon={<BsSearch />}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="chargeSpeedList-search-boxButton">
                    <Button
                      className="chargeSpeedList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      {t('button.addChargerState')}
                    </Button>
                  </Col>
                </Row>
                <div className="chargeSpeedList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>{t('chargeSpeedForm.chargingStationSpeed')}</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('chargeSpeedForm.chargingStationSpeedIcon')}</span>
                              <span className="ico" onClick={() => handleSorting('icon', sortByItem)}>
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>{t('chargeSpeedForm.chargingStationSpeedOrder')}</span>
                              <span className="ico" onClick={() => handleSorting('order', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>{t('chargeSpeedForm.action')}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">{t('placeHolder.loading')}</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(chargerSpeedData) ? (
                          <tr>
                            <td colSpan={3} className="border-0">
                              <div className="empty-data-block">{t('chargeSpeedForm.noData')}</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(chargerSpeedData, (item, key) => {
                            return (
                              <>
                                <tr key={`chargeSpeed-${key}`}>
                                  <td>{_.get(item, 'name', '')}</td>
                                  <td>
                                    <Avatar imgSrc={_.get(item, 'icon', '')} className="connectorTypeList-logo" />
                                  </td>
                                  <td>{typeof item.order === 'number' ? item.order : '-'}</td>
                                  <td>
                                    <span
                                      className="chargeSpeedList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getChargeSpeedDetail(_.get(item, 'id', ''));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 title="Edit" />
                                    </span>
                                    <span
                                      className="chargeSpeedList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setChargeSpeedId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine title="Delete" />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(chargerSpeedData) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                  // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                )}
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <ChargeSpeedForm onClose={handleCloseFormChargeSpeed} isEdit={isEdit} onSuccess={getChargeSpeed} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="chargeSpeed" onClose={handleCloseDeleteModel} onRemove={deleteChargeSpeed} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default ChargeSpeedList;
